import client from './client';
import type { Campaign, SendingDomain } from '../types';

export interface SendingDomainRequest {
  domain: string;
  dkim_selector?: string;
  comment?: string;
}

export interface MailCheck {
  name: string;
  status: 'pass' | 'missing' | 'invalid' | 'error';
  detail: string;
  records: string[];
}

export interface DomainImpersonation {
  allowed: boolean;
  reason: string;
}

export interface DomainScanResult {
  domain: string;
  spf: MailCheck;
  dkim: MailCheck[];
  dmarc: MailCheck;
  mx: MailCheck;
  impersonation?: DomainImpersonation;
}

export interface SpoofExerciseRequest {
  domain: string;
  group_id: number;
  smtp_id: number;
}

export interface AssessmentSuggestion {
  title: string;
  reason: string;
  practice: string;
}

export interface AssessmentSuggestions {
  domain: string;
  summary: string;
  suggestions: AssessmentSuggestion[];
}

export interface AssessmentMaterialRequest {
  kind: 'email' | 'landing';
  domain: string;
  title: string;
  reason: string;
  practice: string;
}

export interface AssessmentMaterial {
  kind: 'email' | 'landing';
  name: string;
  subject?: string;
  html: string;
  text?: string;
  preview_html?: string;
}

export const sendingDomainsApi = {
  getAll: () => client.get<SendingDomain[]>('/sending-domains/'),
  getById: (id: number) => client.get<SendingDomain>(`/sending-domains/${id}`),
  create: (data: SendingDomainRequest) => client.post<SendingDomain>('/sending-domains/', data),
  update: (id: number, data: SendingDomainRequest) => client.put<SendingDomain>(`/sending-domains/${id}`, { ...data, id }),
  delete: (id: number) => client.delete<{ success: boolean; message: string }>(`/sending-domains/${id}`),
  verify: (id: number) => client.post<SendingDomain>(`/sending-domains/${id}/verify`, {}),
  scan: (domain: string, dkimSelectors: string[]) =>
    client.post<DomainScanResult>('/sending-domains/scan', { domain, dkim_selectors: dkimSelectors }),
  suggest: (scan: DomainScanResult) => client.post<AssessmentSuggestions>('/sending-domains/suggestions', scan),
  material: (data: AssessmentMaterialRequest) => client.post<AssessmentMaterial>('/sending-domains/materials', data),
  spoofExercise: (data: SpoofExerciseRequest) => client.post<Campaign>('/sending-domains/spoof-exercise', data),
};
